import React from "react";
import { motion } from "framer-motion";

const ease = [0.33, 1, 0.68, 1];

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease, delay }}
    {...props}
  >
    {children}
  </motion.div>
);

// Masked line reveal — reliable fade + rise (won't get stuck hidden)
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ opacity: 0, y: "45%" }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease, delay }}
    >
      {children}
    </motion.span>
  </span>
);

// Overline tag
export const Overline = ({ children, className = "" }) => (
  <span className={`overline text-[#1C7C54] ${className}`}>{children}</span>
);
